import Icon from 'veui/components/Icon'
import { IconChevronUp } from 'dls-icons-vue'

Icon.register('chevron-up', IconChevronUp)
